/* eslint-disable func-names */
import { CLEAR_MESSAGE, SET_MESSAGE } from '../actions/authActions';


const initialState = {};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_MESSAGE:
      return { message: payload };

    case CLEAR_MESSAGE:
      return { };

    default:
      return state;
  }
}
